export default "assets/images/icons/entity-features-ab1e0857.svg";